import * as React from "react";
import { Grid, Link, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

interface Props {
  patientsCount: string;
  currentProgramName: any;
  showConfirmUnassign: boolean;
  setShowConfirmUnassign: any;
  handleConfirmUnassign: any;
}

const UnassignConfirmModal: React.FC<Props> = ({
  patientsCount,
  currentProgramName,
  showConfirmUnassign,
  setShowConfirmUnassign,
  handleConfirmUnassign,
}) => {
  return (
    <Modal open={showConfirmUnassign} className="follow-up-modal">
      <div className="paper" style={{ width: "545px", padding: "0px" }}>
        <div className="paperInner" style={{ padding: "0px" }}>
          <Grid
            container
            className="fum-header-container"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <h1 className="fum-header">Transfer Patients from Program</h1>
            <Link
              onClick={() => setShowConfirmUnassign(false)}
              style={{ color: "black", paddingRight: "20px" }}
            >
              <CloseIcon />
            </Link>
          </Grid>
          <div className="divider-orange" style={{ margin: "0px" }}></div>

          <Grid
            container
            style={{ padding: "24px" }}
            alignItems={"center"}
            spacing={4}
          >
            <Grid item xs={12} md={12} className="subdued-text">
              You are about to unassign <b>{patientsCount} patient(s)</b> from{" "}
              {currentProgramName}. This action cannot be undone. Patients will
              no longer be enrolled in this program.
            </Grid>
          </Grid>

          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            style={{ padding: "30px" }}
          >
            <Grid
              item
              xs={4}
              className="cancel-link-container"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <Link
                className="cancel-link"
                onClick={() => setShowConfirmUnassign(false)}
              >
                Cancel
              </Link>
            </Grid>
            <Grid item xs={4} className="confirm-btn-container">
              <Link
                onClick={handleConfirmUnassign}
                className="confirm-btn"
                style={{ width: "135px" }}
              >
                Unassign
              </Link>
            </Grid>
          </Grid>
        </div>
      </div>
    </Modal>
  );
};

export default UnassignConfirmModal;
